import axios from "../../../../api/axios";

import { Sport } from "../types/sports.types";

export const getSports = async (): Promise<Sport[]> => {
  const response = await axios.get("/goalngo-sports");
  return response.data.data;
};
